import { MtBase } from './MtBase';
import { MtObject } from './MtObject';

export class MtWork extends MtBase {
  Objects: MtObject[];
  Designation?: string;
  ObjectDesignation?: string;
  Status?: string;
  Order?: string;
  ExecutionFrom?: any;
  ExecutionPlanned?: any;
  ExecutionTo?: any;
  SortOrder?: number;
  MasterObjectType?: number;
  MasterObjectTypeDesignation?: string;
  Street?: string;
  District?: string;
}

export class MtObjectWork extends MtBase {
  Designation?: string;
  State?: string;
  Order?: string;
  EarliestExecutionDate?: any;
  ScheduledExecutionDate?: any;
  LatestExecutionDate?: any;
  ObjWorkTypeDesignation?: string;
}

export class MtObjWorkType extends MtBase {
  ObjectId: string;
  WorkTypeId: string;
  Object: string;
  MasterObjectType?: string;
  ObjectState?: number;
  Subject?: string;
  Street?: string;
  District?: string;
  WorkType: string;
  Designation?: string;
  Description?: string;
  CycleLength?: number;
  CycleUnit?: number;
  CycleUnitText?: string;
  ExecFirst?: any;
  ExecLast?: any;
  ExecTime?: number;
  LeadTime?: number;
  EarliestExecutionDate?: any;
  ScheduledExecutionDate?: any;
  LatestExecutionDate?: any;

  WorkState?: number;
  WorkStateText?: string;

  IsValidEarliestExecutionDate?: boolean;
  IsValidMtObjWorkType?: boolean;
  HasExistingWorks?: boolean;
}

export class CategorizedMtObjWorkTypesWithStates {
  ObjectsWithGenerableWorks: MtObjWorkType[] = [];
  ObjectsWithAvailableWorks: MtObjWorkType[] = [];
  ObjectsWithoutUpcomingWorks: MtObjWorkType[] = [];
  ObjectsWithGeneratedWorks: MtObjWorkType[] = [];
  ObjectsWorkGenerationFailed: MtObjWorkType[] = [];
}
